/**
 * Created by Jerker Nord on 2018-12-05.
 */

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorReelView} from "../reelarea/ThorReelView";
import {ThorReelBackgroundController} from "../reelbackground/ThorReelBackgroundController";
import {ThorNudgeReelPartAnimator} from "./ThorNudgeReelPartAnimator";

export class ThorRespinNudgeReelController extends NudgeSpinReelController {

    public static readonly ENABLE_LIT_SYMBOL:string = "ThorRespinNudgeReelController_enableRuneRazeSymbol";

    private _reelBackgroundController:ThorReelBackgroundController;
    private _reelsToNudge:boolean[] = [false, false, false, false, false];
    private _previousReelsToNudge:boolean[] = [false, false, false, false, false];
    private _isRestoreState:boolean;
    private _litSymbolEnabled:boolean;
    private _litSymbol:string;

    protected _removedSymbolPool:StateReelSymbol[];

    constructor(reelId:number) {
        super(reelId);
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ThorRespinNudgeReelController.ENABLE_LIT_SYMBOL, (event:GameEvent) => this.onEnableRuneRazeSymbol(event.params[0]));
    }

    protected onInitDataParsed(data:ParsedInitData):void {
        super.onInitDataParsed(data);
        this._isRestoreState = data.isRestoreState;
        if(!this._isRestoreState && this.reelId === 2) {
            this._stopReelSet.forEach((item, i) => { if(item == "M2") this._stopReelSet[i] = "M5"; });
        }
    }

    public onGameDataParsed(data:INudgeParsedGameData):void {
        this._isRestoreState = false;
        super.onGameDataParsed(data);
    }

    private onEnableRuneRazeSymbol(runeRazeSymbol:string):void {
        this._litSymbolEnabled = true;
        this._litSymbol = runeRazeSymbol;
    }

    protected addNewSymbol(symName:string, state?:ISymbolStateConfig):StateReelSymbol {
        if(this._litSymbolEnabled == true && symName == this._litSymbol) {
            state = ThorGameConfig.instance.SYMBOL_STATES.spinGlow;
        } else if(this._isSpinBlurred) {
            state = GameConfig.instance.SYMBOL_STATES.spin;
        } else {
            state = state == undefined ? GameConfig.instance.SYMBOL_STATES.normal : state;
        }

        const symbol:StateReelSymbol = this._reelPartCreator.createNewSymbol(symName, this._reelId, state, {
            width : this._reelPartAnimator.symWidth,
            height : this._reelPartAnimator.symHeight,
            bottomPadding : this._reelPartAnimator.symBottomPadding
        });
        symbol.x = 0;
        symbol.y = -symbol.symHeight / 2 - GameConfig.instance.REEL_AREA_POS_Y - GameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId][1]; // this is just a temp position that's not visible. this position might be visible in portrait mode but it doens't matter.
        this._reelView.addChild(symbol);

        return symbol;
    }

    private setPreviousReelsToNudge():void {
        for(let i:number = 0; i < this._reelsToNudge.length; i++) {
            this._previousReelsToNudge[i] = this._reelsToNudge[i];
        }
    }

    protected parseDoNudge(data:INudgeParsedGameData):boolean {
        this.setPreviousReelsToNudge();
        this._reelsToNudge = [false, false, false, false, false];
        if(data.mode == ThorGameMode.SCATTER_RESPIN || data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            for(let i:number = 0; i < data.reels.length; i++) {
                for(let j:number = 3; j < 6; j++) {
                    if(data.reels[i][j] == "S") {
                        this._reelsToNudge[i] = true;
                        break;
                    } else {
                        this._reelsToNudge[i] = false;
                    }
                }
            }
        }
        // Nudge Bonus symbol main game?
        if((data.mode == ThorGameMode.NUDGE_RESPIN || data.nextMode == ThorGameMode.NUDGE_RESPIN) && this.reelId == 4) {
            this._reelsToNudge[4] = true;
        }

        //Nudge Bonus symbol FS?
        if((data.mode == ThorGameMode.NUDGE_RESPIN_FS || data.nextMode == ThorGameMode.NUDGE_RESPIN_FS) && this.reelId == 4) {
            this._reelsToNudge[4] = true;
        }
        if((data.mode == ThorGameMode.FREESPIN || data.nextMode == ThorGameMode.NUDGE_RESPIN_FS) && this.reelId == 4) {
            this._reelsToNudge[4] = true;
        }

        if(this._isRestoreState == true) {
            this.setPreviousReelsToNudge();
        }

        return this._previousReelsToNudge[this._reelId];
    }

    protected createReelPartAnimator():SpinReelPartAnimator {
        const reelPartAnimator:ThorNudgeReelPartAnimator = <ThorNudgeReelPartAnimator>super.createReelPartAnimator();
        this._reelBackgroundController = new ThorReelBackgroundController(this._reelId);
        (<ThorNudgeReelPartAnimator>reelPartAnimator).reelBackgroundController = this._reelBackgroundController;
        return reelPartAnimator;
    }

    protected onSpinStopStarted():void {
        super.onSpinStopStarted();

        this._reelBackgroundController.animateStopSpin(this._reelPartAnimator.isQuickStop ? this.getSpinQuickStopEase() : this.getSpinStopEase());
        (<ThorReelView>this._reelView).playReelStopDustAnimation();
    }

    protected getSpinStopEase():any {
        return CustomEase.create("custom", "M0,0,C0.058,0.259,0.104,0.494,0.212,0.654,0.33,0.83,0.172,0.959,0.312,1,0.352,1.01,0.377,1.008,0.456,0.99,0.515,0.975,0.624,0.982,0.668,0.982,0.706,0.982,0.67,0.998,0.684,1,0.706,1.002,0.943,1,1,1");
    }

    protected getSpinQuickStopEase():any {
        return CustomEase.create("custom", "M0,0,C0.058,0.259,0.104,0.494,0.212,0.654,0.33,0.83,0.172,0.959,0.312,1,0.352,1.01,0.377,1.008,0.456,0.99,0.515,0.975,0.624,0.982,0.668,0.982,0.706,0.982,0.67,0.998,0.684,1,0.706,1.002,0.943,1,1,1");
    }

    protected onSpinStopAnimationCompleted():void {
        super.onSpinStopAnimationCompleted();
        this._litSymbolEnabled = false;
    }

    /*
    protected fillUpStopReelSetTop():string[] {
        const result:string[] = [];
        const topSym:string = (this._extraTopSymbols != null && this._doNudge) ? this._extraTopSymbols[0] : this._stopReelSet[0];
        const stackedName:IParsedStackedSymbolName = StateReelSymbol.parseStackedSymbolName(topSym);
        if(stackedName.isStacked && stackedName.index > 0) {
            for(let i:number = 0; i < stackedName.index; i++) {
                result.push(`${stackedName.symName}*${i}`);
            }
        }

        return result.concat(this._extraTopSymbols != null && this._doNudge ? this._extraTopSymbols : []);
        // TODO: shall check if the extraTopSymbols bottom match the top of the stopReelSet?
    }
    */

    public abortNudge(steps?:number):void {
        super.abortNudge(steps);
        if(this._nudgeAnimator.aborted) {
            this._reelBackgroundController.abortNudge();
        }
    }
}